import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { useFirebaseStore } from '@/stores/firebase'
import './types/html-ele-extension.d.ts'
import 'vue-data-ui/style.css'
import VueClickAway from 'vue3-click-away'
import * as Sentry from '@sentry/vue'

import { createSentryPiniaPlugin } from '@sentry/vue'

import App from './App.vue'
import router from './router'

const app = createApp(App)
const pinia = createPinia()

if (import.meta.env.MODE === 'production') {
  Sentry.init({
    app,
    dsn: 'https://20bb4aa5692579abe7c0a8bd0aa04748@o4506557203546112.ingest.us.sentry.io/4509036995346432',
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.feedbackIntegration({
        // Additional SDK configuration goes in here, for example:
        formTitle: 'Feedback',
        triggerLabel: 'Feedback',
        colorScheme: 'system',
        messagePlaceholder: "What's your feedback? What's the bug? What did you expect?",
      }),
    ],
    // Tracing
    tracesSampleRate: 0.2, // Capture 20% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  })

  pinia.use(createSentryPiniaPlugin())
}

app.use(VueClickAway)
app.use(pinia)

const firebaseStore = useFirebaseStore()

// Wait for auth to initialize before setting up router
// Creates a blocking operation that waits for a promise to resolve before continuing
firebaseStore
  .init()
  .then(() => {
    // Success path - normal app initialization
    app.use(router)
    app.mount('#app')
  })
  .catch((error) => {
    // Error path - could show an error screen or fallback experience
    console.error('Authentication initialization failed:', error)

    // Find this property later to conditionally show auth error issues
    app.config.globalProperties.$authError = error.message
    app.mount('#app')
  })
